<script setup lang="ts">
import SearchIcon from '@/assets/icons/SearchIcon.vue';
import SelectionPopoverDivider from './SelectionPopoverDivider.vue';
import { useTemplateRef } from 'vue';

defineOptions({ name: 'SelectionPopoverSearchHeader' });

const searchText = defineModel<string>({ required: true });

const props = defineProps<{
  placeholder: string;
}>();

const searchInputRef = useTemplateRef('searchInputRef');

const focus = (): void => searchInputRef.value?.focus();

defineExpose({ focus });
</script>

<template>
  <div class="sticky top-0 z-10 shrink-0 bg-surface-primary px-smd pt-smd">
    <div class="flex min-h-11 w-full items-center gap-sm rounded-input py-sm pl-smd pr-md">
      <SearchIcon class="size-icon-md shrink-0 text-secondary" />
      <input
        ref="searchInputRef"
        v-model="searchText"
        type="text"
        :placeholder="props.placeholder"
        :aria-label="props.placeholder"
        class="w-full min-w-0 border-none bg-transparent text-body text-primary outline-none placeholder:text-secondary"
      />
    </div>
    <SelectionPopoverDivider />
  </div>
</template>
